// src/i18n.js
import { createI18n } from 'vue-i18n'
import zhTW from './locales/zh-TW.json'
import en from './locales/en.json'

const STORAGE_KEY = 'app_locale'

function resolveInitialLocale() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'zh-TW' || saved === 'en') return saved
  const browserLang = typeof navigator !== 'undefined' ? (navigator.language || '').toLowerCase() : ''
  return browserLang.startsWith('zh') ? 'zh-TW' : 'en'
}

const i18n = createI18n({
  legacy: false,
  locale: resolveInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    'zh-TW': zhTW,
    en
  }
})

export function setLocale(locale) {
  i18n.global.locale.value = locale
  localStorage.setItem(STORAGE_KEY, locale)
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', locale === 'zh-TW' ? 'zh-Hant-TW' : 'en')
  }
}

// 初始化同步 <html lang>
if (typeof document !== 'undefined') {
  const initial = i18n.global.locale.value
  document.documentElement.setAttribute('lang', initial === 'zh-TW' ? 'zh-Hant-TW' : 'en')
}

export default i18n
